import { render, staticRenderFns } from "./SessionsPerProductTypeTable.vue?vue&type=template&id=b4936e30&scoped=true"
import script from "./SessionsPerProductTypeTable.vue?vue&type=script&lang=ts"
export * from "./SessionsPerProductTypeTable.vue?vue&type=script&lang=ts"
import style0 from "./SessionsPerProductTypeTable.vue?vue&type=style&index=0&id=b4936e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4936e30",
  null
  
)

export default component.exports